/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
// console.log("Hello World! (from create-block-bloque-popup-form block)");
/* eslint-enable no-console */


document.addEventListener("DOMContentLoaded", function(event) {
    activarPopupForms();
});


function activarPopupForms(){
    console.log('activarPopupForms');
    // cercar els popup forms disponibles a la pàgina
    $popups = document.querySelectorAll('.popup');

    

    if($popups.length>0){
        for (let $i = 0; $i < $popups.length; $i++) {
            let $popup = $popups[$i];
            
            // obtain id del popup
            if($popup.id){
                // cercar triggers pel popup actual
                $triggers = document.querySelectorAll('.trigger>a[rel=' + $popup.id + '],.trigger[rel=' + $popup.id + ']');                
                if($triggers.length>0){
                    for (let $j = 0; $j < $triggers.length; $j ++) {
                        let $trigger = $triggers[$j];
                        $trigger.addEventListener('click', function($e){
                            //$link = this.querySelector('a');
                            if(this.rel){
                                $_popup = document.querySelector('#' + this.rel + '.popup');
                                if($_popup){
                                    $_popup.classList.add('active');
                                }
                            }
                        })
                        
                    }
                }
                $closeBtn = $popup.querySelector('.close');
                if($closeBtn){
                    $closeBtn.addEventListener('click', function(e){
                        this.closest('.popup').classList.remove('active');
                    })
                }

            }
        }
    }

    

    // $docentes = document.querySelectorAll('.list-docentes .open-close');

    // if($docentes.length>0){
    //     for (let $i = 0; $i < $docentes.length; $i++) {
    //         const $docenteCtrl = $docentes[$i];
    //         $docenteCtrl.addEventListener('click', function(){

    //             this.closest('.docente').classList.toggle('closed');
    //         })
            
    //     }
    // }
}